/**
 * @type {string}
 * @description - The zoom modal web component.
 */
export const ZOOM_MODAL_WEB_COMPONENT = 'zoom-modal-component';

/**
 * @type {string}
 * @description Custom attribute for setting the zoom modal attribute.
 */
export const ZOOM_MODAL_ATTRIBUTE = 'zoom-modal';

/**
 * @type {string}
 * @description - The custom common modal web component.
 */
export const CUSTOM_COMMON_MODAL_WEB_COMPONENT_ATTRIBUTE = '[data-custom-common-modal]';

/**
 * @type {string}
 * @description - The custom zoom modal loading spinner web component.
 */
export const CUSTOM_ZOOM_MODAL_LOADING_SPINNER_WEB_COMPONENT =
    '[data-zoom-modal-spinner]';
